import { render, staticRenderFns } from "./GermplasmAttributeTable.vue?vue&type=template&id=5b88d3f3&"
import script from "./GermplasmAttributeTable.vue?vue&type=script&lang=js&"
export * from "./GermplasmAttributeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports